module.exports = __webpack_public_path__ + "img/avon-fighting-breast-cancer-10.36f131f7.jpg";